const LINKS_DICTIONARY = {
  // Общая очередь - разделы «Уведомления, почтовые события», «Подача заявки абитуриента» (за исключением шагов 7,8), «Проживание»
  'default': 'mailto:abit@hse.ru',
  // Очередь «Участие в олимпиадах» - шаг 7 раздела подачи заявки V
  'olympiads': 'mailto:abit@hse.ru',
  // Очередь «Индивидуальные достижения» - шаг 8 раздела подачи заявки V
  'achievements': 'mailto:abit@hse.ru',
  // Очередь по разделу «Авторизация / регистрация / восстановление доступа» V
  'auth': 'mailto:abit@hse.ru',
  // Очередь по согласиям - раздел «Список конкурсов, управление согласиями» V
  'applications': 'mailto:abit@hse.ru',
  // Очередь по ВИ - раздел «Управление вступительными испытаниями» V
  'innerExams': 'mailto:abit@hse.ru',
  // Очередь Договоры - по разделам «Управление договорами» и «ЛК законного представителя» V - ЛК представителя нет страницы
  'contract': 'mailto:abit@hse.ru',
  // Очередь по признаниям - раздел «Признание документов об иностранном образовании» - нет страницы
  'nostrification': 'mailto:abit@hse.ru',
  // Очередь по редактированию заявки абитуриента V
  'edit': 'mailto:abit@hse.ru'
}

export const state = () => ({
  title: 'Нужна помощь?',
  icon: 'Headset.svg',
  link: '/need-help',
  edit: false
})

export const actions = {
  setLink({commit}, type) {
    commit('SET_LINK', type);
  },
  setIsEdit({commit}, edit) {
    commit('SET_IS_EDIT', edit);
  }
}

export const mutations = {
  SET_LINK(state, type) {
    if (!type || !Object.keys(LINKS_DICTIONARY).includes(type)) {
      state.link = LINKS_DICTIONARY.default;
    } else {
      state.link = LINKS_DICTIONARY[type];
    }
  },
  SET_IS_EDIT(state, edit) {
    state.edit = edit;
  }
}

export const getters = {
  get: (state) => {
    return state;
  },
  getIsEdit: (state) => {
    return state.edit;
  }
}
